import { Navigate, Outlet } from "react-router-dom";
import React, { useEffect } from "react";
import {
  fetchUserAction,
  fetchProfileAction,
} from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { ActionTypes } from "../../../redux/constants/action-types";

export const PrivateRoute = ({
  children,
  user,
  is_user,
  profile,
  is_profile,
  signInDetails,
  setSigninDetails,
  fetchUser,
  fetchProfile,
}) => {
  const fetchData = () => {
    if (Object.keys(user).length === 0 && is_user === false) {
      fetchUser();
    }
    if (
      Object.keys(profile).length === 0 &&
      is_profile === false &&
      Object.keys(user).length > 0
    ) {
      fetchProfile(user.id);
    }
    if (
      Object.keys(signInDetails).length === 0 &&
      localStorage.getItem("access_token")
    ) {
      const data = {
        access_token: localStorage.getItem("access_token"),
        refresh_token: localStorage.getItem("refresh_token"),
        token_type: "Bearer",
        expires_in: "36000",
        scope: "read write",
      };
      setSigninDetails(data);
    }
  };
  setInterval(() => {
    localStorage.removeItem("access_token");
  }, 35500000);
  useEffect(() => {
    fetchData();
  });
  return (
    <>
      {Object.keys(user).length === 0 ? (
        ""
      ) : user.is_email && user.is_email ? (
        <Outlet />
      ) : (
        <Navigate replace to="settings/email-activation" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const signInDetails = state.authentication.signInDetails;
  const user = state.user.user;
  const is_user = state.user.is_user;
  const profile = state.user.profile;
  const is_profile = state.user.is_profile;
  return {
    signInDetails: signInDetails,
    user: user,
    is_user: is_user,
    profile: profile,
    is_profile: is_profile,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchUser: () => dispatch(fetchUserAction()),
    fetchProfile: (userId) => dispatch(fetchProfileAction(userId)),
    setSigninDetails: (data) =>
      dispatch({
        type: ActionTypes.SIGNIN_SUCCESS,
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
